<template>
  <div class="router-header flex flex-wrap items-center mb-6">
    <div
      class="content-area__heading"
      :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : route.meta.breadcrumb}"
    >
      <h2 class="mb-1">{{ $t(route.meta.pageTitle) }}</h2>
    </div>
    <!-- BREADCRUMB -->
    <vx-breadcrumb
      class="ml-4 md:block hidden"
      v-if="route.meta.breadcrumb"
      :route="route"
      :isRTL="isRTL"
    />
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: 'vx-title-bar',
  props: {
    route: Object,
    isRTL: Boolean
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxInputGroup.scss";
</style>
